# NOTE: Still used on new company form
import React from "react"
import PropTypes from "prop-types"
import { MultipleDropdown } from '@makeably/creativex-design-system'
import { toggleValue } from 'utilities/array'

class MultiSelect extends React.Component
  @propTypes =
    allowClear: PropTypes.bool
    containerClassName: PropTypes.string
    disabled: PropTypes.bool
    inputName: PropTypes.string
    onChange: PropTypes.func
    options: PropTypes.arrayOf(
      PropTypes.shape(
        disabled: PropTypes.bool
        label: PropTypes.string
        value: PropTypes.string
      )
    )
    placeholder: PropTypes.string
    selected: PropTypes.array

  @defaultProps =
    allowClear: true
    selected: []

  renderHiddenInput: (value, idx) =>
    inputName = @props.inputName
    `<input key={idx} type="hidden" name={inputName} value={value} />`

  render: ->
    `<div className={this.props.containerClassName}>
      {this.props.selected.map(this.renderHiddenInput)}
      <MultipleDropdown
        options={this.props.options}
        onChange={(value) => {
          this.props.onChange(toggleValue(this.props.selected, value.value))
        }}
        selected={this.props.options.filter((option) => (this.props.selected).includes(option.value))}
        placeholder="choose from..."
        onSelectAll={(all) => this.props.onChange(all.map((option) => option.value))}
      />
    </div>`

export default MultiSelect
